<h3 mat-dialog-title>{{title}}</h3>
<div mat-dialog-content>
  <div class="dialog-container">
    <form [formGroup]="objCreateFormGroup">
      <mat-form-field>
          <mat-label>Site</mat-label>
          <mat-select placeholder="Site" formControlName="display_name" (selectionChange)="select()" cdkFocusInitial>
            <mat-option *ngFor="let d of plantList" [value]="d.display_name">{{d.display_name}}</mat-option>
          </mat-select>
      </mat-form-field>

      <!-- START: Remove as part of ITMFG-44979 -->
      <div style="display:flex; flex-direction: row-reverse; margin-top: 0px;">
        <mat-label style="font-size: 10px;">Override Standardized Work Line and Sub Line</mat-label>
        <mat-checkbox class="example-margin" formControlName="line_override" (change)="selectOverride()"></mat-checkbox>
      </div>
      <!-- END -->

      <mat-form-field [class.hideField]="lineOverride">
          <mat-label>Line</mat-label>
          <mat-select placeholder="Line" formControlName="line" (selectionChange)="selectLine()" cdkFocusInitial>
            <mat-option *ngFor="let d of lineListFiltered" [value]="d.line_id">{{d.line}}</mat-option>
          </mat-select>
      </mat-form-field>

      <mat-form-field [class.hideField]="lineOverride">
          <mat-label>Sub Line</mat-label>
          <mat-select placeholder="Sub Line" formControlName="subline" (selectionChange)="selectSubLine()" cdkFocusInitial>
            <mat-option *ngFor="let d of subLineListFiltered" [value]="d.subline_id">{{d.subline}}</mat-option>
          </mat-select>
      </mat-form-field>

      <!-- START: Remove as part of ITMFG-44979 -->
      <mat-form-field [class.hideField]="!lineOverride">
        <mat-label>Section</mat-label>
        <textarea matInput cdkTextareaAutosize formControlName="section"></textarea>
      </mat-form-field>

      <mat-form-field [class.hideField]="!lineOverride">
        <mat-label>Sub Section (optional)</mat-label>
        <textarea matInput cdkTextareaAutosize formControlName="subsection"></textarea>
      </mat-form-field>
      <!-- END -->
          
      <mat-form-field>
          <mat-label>Object ID</mat-label>
          <textarea  matInput cdkTextareaAutosize formControlName="objectID"></textarea>
      </mat-form-field>
      
      <mat-form-field>
          <mat-label>Description</mat-label>
          <textarea matInput cdkTextareaAutosize formControlName="manualDescript"></textarea>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Minutes Before Shift to Load</mat-label>
        <textarea matInput cdkTextareaAutosize formControlName="loadtime"></textarea>
      </mat-form-field>

      <mat-checkbox formControlName="manualLoad">Manual Load</mat-checkbox>

      <div style="margin-bottom: 0px; margin-top: 0px;">
        <mat-checkbox class="example-margin"  formControlName="requireComment">Require Comment for "Complete (OK)"</mat-checkbox>
      </div>

      <div style="margin-bottom: 0px; margin-top: 0px;">
        <mat-checkbox class="example-margin"  formControlName="optionalComment">Optional Comment for "Complete (OK)"</mat-checkbox>
      </div>

      <mat-form-field>
          <mat-label>Require Work Request</mat-label>
          <mat-select placeholder="Require Work Request" formControlName="requireWorkRequest" cdkFocusInitial>
            <mat-option *ngFor="let d of workRequestTypeList" [value]="d.type">{{d.display_type}}</mat-option>
          </mat-select>
      </mat-form-field>

      <div style="margin-bottom: 0px; margin-top:0px;">
        <mat-checkbox class="example-margin"  formControlName="defaultEAMAsset">Default EAM Asset</mat-checkbox>
      </div>
      
      <div *ngIf="assetListLoading">
        <div class="spinner-wrapper">
            <span>Loading Asset List </span>
            <mat-spinner [diameter]="20"></mat-spinner>
          </div>
        <mat-divider></mat-divider>
      </div>
      <div *ngIf="!assetListLoading" class="eam-assetid">
        <div class="eam-assetid-input">
          <mat-form-field>
              <input type="text"
                placeholder="Type to Search Asset Number (optional)"
                aria-label="Asset"
                matInput
                formControlName="assetNum"
                [matAutocomplete]="auto">

            <mat-autocomplete  #auto="matAutocomplete">
              <div *ngIf="showAutoComplete">
                <cdk-virtual-scroll-viewport itemSize="5" minBufferPx="200" maxBufferPx="400" class="eamassets-viewport-select">
                  <mat-option *cdkVirtualFor="let option of filteredOptions | async" [value]="option.AssetNumber" [ngStyle]="{'color':option.Maintainable_flag === 'N' ? 'red' : 'black'}">
                    {{option.AssetNumber}}<span *ngIf="(isScreen$ | async)?.matches">&nbsp; &nbsp; &nbsp; &nbsp;  ({{option.Description}})</span>
                  </mat-option>
                </cdk-virtual-scroll-viewport>
              </div>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="eam-assetid-search">
          <button mat-button class="mat-raised-button" (click)="openEAMLookup()" ><mat-icon>search</mat-icon></button>
        </div>
      </div>
    </form>  
  </div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="saveData()" >Save</button>
  <button mat-raised-button (click)="onNoClick()">Cancel</button>
  <div *ngIf="showInvalidAsset" style="color: red">The Asset Number field must be blank or contain a valid EAM asset number</div>
 </div>

